import cn from 'classnames';

import Text from 'components/common/Text';
import ThankYouButton from 'components/signUpFunnel/thankYou/ThankYouButton';
import { TEMPO } from 'lib/constants';

const SmartPhoneLegalCopy = ({ onClick, postSignupUrl, user, brand }) => {
  const isTempo = brand === TEMPO;

  return (
    <>
      <div className={cn({ 'bg-tempo-gray-40': isTempo, 'bg-cream-100': !isTempo })}>
        <div className="mx-auto flex items-center justify-center pb-4">
          <ThankYouButton
            onClick={onClick}
            postSignupUrl={postSignupUrl}
            user={user}
            buttonStyles="w-[345px] min-[376px]:w-96"
          />
        </div>
        <div className="mt-6 pb-16">
          <Text brandStylesOverrides="textSm" className="mx-8 mb-8 text-left">
            Valid for new customers only. Referral credit limited to one per new household address,
            and cannot be combined with any other Home Chef offers, promotions, or discounts. Your
            promotional discount recipient can freely choose to skip or cancel future deliveries
            free of charge once they redeem their referral credit.
          </Text>
          <Text brandStylesOverrides="textSm" className="mx-8 text-left">
            You agree to share your Home Chef referral link only with your own personal connections
            via email, your own social media accounts, and personal blogs where you are the primary
            content owner. Public distribution on sites where you are not the primary content owner,
            e.g. Home Chef’s social media pages and coupon websites, is not allowed. We reserve the
            right to suspend your account and/or revoke any and all referral credits at any time if
            we believe that your credits were inappropriately earned.
          </Text>
        </div>
      </div>
    </>
  );
};

SmartPhoneLegalCopy.propTypes = {
  brand: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  postSignupUrl: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
};

export default SmartPhoneLegalCopy;
